<template>
  <v-list-tile class="form-line-global-item">
    <v-list-tile-content class="left" :class="{ invalid: !valid }">{{
      item.label
    }}</v-list-tile-content>
    <v-list-tile-action v-if="!editMode || item.readOnly" class="right">
      <div class="d-flex multi-container" style="width :100%;">
        <FormLineReadOnly
          :key="i.name"
          :item="i"
          :value="value"
          v-for="i in items"
        ></FormLineReadOnly>
      </div>
    </v-list-tile-action>
    <v-list-tile-action v-else class="right">
      <div class="d-flex multi-container" style="width :100%;">
        <FormLineField
          :item="i"
          :value="i.value || value"
          @input="onInput"
          @invalid="onInvalid"
          :key="i.name"
          :address-is-valid-at-beginning="addressIsValidAtBeginning"
          v-for="i in items"
        >
        </FormLineField>
      </div>
    </v-list-tile-action>
    <v-list-tile-avatar v-if="item.as === 'link' || linkValue != null">
      <a
        :href="linkValue ? linkValue : value[item.name]"
        target="_blank"
        class="ml-3"
      >
        <v-icon color="primary">link</v-icon>
      </a>
    </v-list-tile-avatar>
  </v-list-tile>
</template>

<script>
import { checkFormLine } from "../../utils";
import FormLineField from "./FormLineField";
import FormLineReadOnly from "./FormLineReadOnly";

export default {
  components: { FormLineReadOnly, FormLineField },
  props: ["item", "value", "editMode", "addressIsValidAtBeginning"],
  data() {
    return {
      valid: true,
      fceUp: 0,
      showMenu: false,
      validAddress: false
    };
  },
  watch: {
    item() {
      this.isValid();
    },
    value() {
      this.isValid();
    }
  },
  mounted() {
    this.validAddress =
      this.item.addressIsValidAtBeginning &&
      this.item.addressIsValidAtBeginning();
    this.isValid();
  },
  computed: {
    items() {
      if (this.item.name instanceof Array && this.item.name.length > 1) {
        const items = [];
        for (let i = 0; i < this.item.name.length; ++i) {
          items.push({
            ...this.item,
            name: this.item.name[i],
            hint: this.item.hint[i],
            validation: this.item.validation[i],
            value: this.item.value instanceof Array && this.item.value[i]
          });
        }
        return items;
      } else {
        return [{ ...this.item }];
      }
    },
    linkValue() {
      return this.item.linkValue && this.item.linkValue.bind(this)();
    }
  },
  methods: {
    rawData(i) {
      if (this.items[i].value) {
        return this.items[i].value();
      } else if (this.value) {
        let [a, b] = this.items[i].name.split(".");
        if (b != null) {
          return this.value[a] ? this.value[a][b] : "";
        } else {
          return this.value[a];
        }
      } else {
        return null;
      }
    },
    isValid: function() {
      let i = 0;
      for (const item of this.items) {
        if (!checkFormLine(item.validation, this.rawData(i), this.value)) {
          return (this.valid = false);
        }
        ++i;
      }
      return (this.valid = true);
    },
    onInput: function($event) {
      this.$emit("input", $event);
      this.isValid();
      this.$forceUpdate();
    },
    onInvalid() {
      this.valid = false;
    }
  }
};
</script>
<style scoped>
.left {
  font-size: 11pt;
}
.right {
  width: 60%;
}
.property-value {
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
@media screen and (min-width: 1024px) {
  .form-line-input {
    width: 400px;
  }
}

.invalid {
  color: darkorange;
  font-weight: bold;
}

.multi-container > *:not(:first-child) {
  margin-left: 10px;
}
</style>
